import { defineMessages } from 'react-intl-next';
export var toolbarInsertBlockMessages = defineMessages({
  action: {
    id: 'fabric.editor.action',
    defaultMessage: 'Action item',
    description: 'Also known as a “task”, “to do item”, or a checklist'
  },
  actionDescription: {
    id: 'fabric.editor.action.description',
    defaultMessage: 'Create and assign action items',
    description: ''
  },
  closeInsertRightRail: {
    id: 'fabric.editor.insertRightRail.close',
    defaultMessage: 'Close',
    description: 'Close button label'
  },
  link: {
    id: 'fabric.editor.link',
    defaultMessage: 'Link',
    description: 'Insert a hyperlink'
  },
  linkDescription: {
    id: 'fabric.editor.link.description',
    defaultMessage: 'Insert a link',
    description: 'Insert a hyperlink'
  },
  mediaFiles: {
    id: 'fabric.editor.mediaFiles',
    defaultMessage: 'Image, video, or file',
    description: 'Insert one or more files, videos or images'
  },
  addMediaFiles: {
    id: 'fabric.editor.addMediaFiles',
    defaultMessage: 'Add image, video, or file',
    description: 'Insert one or more files, videos or images'
  },
  insertRightRailTitle: {
    id: 'fabric.editor.insertRightRail.title',
    defaultMessage: 'Insert',
    description: 'Insert a node into the document'
  },
  mediaFilesDescription: {
    id: 'fabric.editor.mediaFiles.description',
    defaultMessage: 'Add images and other files to your page',
    description: 'Insert one or more files or images'
  },
  image: {
    id: 'fabric.editor.image',
    defaultMessage: 'Image',
    description: 'Insert an image.'
  },
  mention: {
    id: 'fabric.editor.mention',
    defaultMessage: 'Mention',
    description: 'Reference another person in your document'
  },
  mentionDescription: {
    id: 'fabric.editor.mention.description',
    defaultMessage: 'Mention someone to send them a notification',
    description: 'Reference another person in your document'
  },
  emoji: {
    id: 'fabric.editor.emoji',
    defaultMessage: 'Emoji',
    description: 'Insert an emoticon or smiley :-)'
  },
  emojiDescription: {
    id: 'fabric.editor.emoji.description',
    defaultMessage: 'Use emojis to express ideas 🎉 and emotions 😄',
    description: 'Insert an emoticon or smiley :-)'
  },
  table: {
    id: 'fabric.editor.table',
    defaultMessage: 'Table',
    description: 'Inserts a table in the document'
  },
  tableDescription: {
    id: 'fabric.editor.table.description',
    defaultMessage: 'Insert a table',
    description: 'Inserts a table in the document'
  },
  tableSelector: {
    id: 'fabric.editor.tableSelector',
    defaultMessage: 'Table size',
    description: 'Opens a table selector that lets you insert a table of custom size'
  },
  tableSelectorDescription: {
    id: 'fabric.editor.tableSelector.description',
    defaultMessage: 'Add a table using popup to select a custom size',
    description: 'Opens a table selector that lets you insert a table of a custom size'
  },
  tableSizeSelectorButton: {
    id: 'fabric.editor.tableSizeSelectorButton',
    defaultMessage: '{numberOfColumns} by {numberOfRows}',
    description: 'Creates a table of custom size'
  },
  tableSizeSelectorPopup: {
    id: 'fabric.editor.tableSizeSelectorPopup',
    defaultMessage: 'Table size selector',
    description: 'Table selector popup to create table of custom size'
  },
  expand: {
    id: 'fabric.editor.expand',
    defaultMessage: 'Expand',
    description: 'Inserts an expand in the document'
  },
  expandDescription: {
    id: 'fabric.editor.expand.description',
    defaultMessage: 'Insert an expand',
    description: 'Inserts an expand in the document'
  },
  decision: {
    id: 'fabric.editor.decision',
    defaultMessage: 'Decision',
    description: 'Capture a decision you’ve made'
  },
  decisionDescription: {
    id: 'fabric.editor.decision.description',
    defaultMessage: 'Capture decisions so they’re easy to track',
    description: 'Capture a decision you’ve made'
  },
  feedbackDialog: {
    id: 'fabric.editor.feedbackDialog',
    defaultMessage: 'Give feedback',
    description: 'Open the feedback dialog from editor'
  },
  feedbackDialogDescription: {
    id: 'fabric.editor.feedbackDialog.description',
    defaultMessage: 'Tell us about your experience using the cloud editor',
    description: 'Description for feedback option under quick insert dropdown'
  },
  horizontalRule: {
    id: 'fabric.editor.horizontalRule',
    defaultMessage: 'Divider',
    description: 'A horizontal rule or divider'
  },
  horizontalRuleDescription: {
    id: 'fabric.editor.horizontalRule.description',
    defaultMessage: 'Separate content with a horizontal line',
    description: 'A horizontal rule or divider'
  },
  date: {
    id: 'fabric.editor.date',
    defaultMessage: 'Date',
    description: 'Opens a date picker that lets you select a date'
  },
  dateDescription: {
    id: 'fabric.editor.date.description',
    defaultMessage: 'Add a date using a calendar',
    description: 'Opens a date picker that lets you select a date'
  },
  placeholderText: {
    id: 'fabric.editor.placeholderText',
    defaultMessage: 'Placeholder text',
    description: 'Inserts a text placeholder into the page'
  },
  placeholderTextDescription: {
    id: 'fabric.editor.placeholderText.description',
    defaultMessage: 'Insert a text placeholder into the page',
    description: 'Inserts a text placeholder into the page'
  },
  columns: {
    id: 'fabric.editor.columns',
    defaultMessage: 'Layouts',
    description: 'Create a multi column section or layout'
  },
  columnsDescription: {
    id: 'fabric.editor.columns.description',
    defaultMessage: 'Structure your page using sections',
    description: 'Create a multi column section or layout'
  },
  columnsDescriptionAdvancedLayout: {
    id: 'fabric.editor.columns.advanced.layout.description',
    defaultMessage: 'Insert {numberOfColumns} equal {numberOfColumns, plural, one {column} other {columns}}',
    description: 'Create a multi column section or layout'
  },
  singleColumnsDescriptionAdvancedLayout: {
    id: 'fabric.editor.columns.advanced.layout.single.description',
    defaultMessage: 'Insert a single column layout',
    description: 'Create a multi column section or layout'
  },
  status: {
    id: 'fabric.editor.status',
    defaultMessage: 'Status',
    description: 'Inserts an item representing the status of an activity to task.'
  },
  statusDescription: {
    id: 'fabric.editor.status.description',
    defaultMessage: 'Add a custom status label',
    description: 'Inserts an item representing the status of an activity to task.'
  },
  viewMore: {
    id: 'fabric.editor.viewMore',
    defaultMessage: 'View more',
    description: 'View more elements that can be inserted'
  },
  viewMoreAriaLabel: {
    id: 'fabric.editor.viewMoreAriaLabel',
    defaultMessage: 'View all elements',
    description: 'A more descriptive aria label describing that users can view all the elements to be inserted.'
  },
  insertMenu: {
    id: 'fabric.editor.insertMenu',
    defaultMessage: 'Insert elements',
    description: 'Opens a menu of additional items that can be inserted into your document.'
  },
  help: {
    id: 'fabric.editor.help',
    defaultMessage: 'Help',
    description: 'Opens up the help dialog'
  },
  helpDescription: {
    id: 'fabric.editor.help.description',
    defaultMessage: 'Browse all the keyboard shortcuts and markdown options',
    description: 'Browse all the keyboard shortcuts and markdown options'
  },
  recordVideo: {
    id: 'fabric.editor.recordVideo',
    defaultMessage: 'Record a Loom video',
    description: 'Record a Loom video'
  },
  addLoomVideo: {
    id: 'fabric.editor.addLoomVideo',
    defaultMessage: 'Record a Loom video',
    description: 'Record a Loom video'
  },
  addLoomVideoComment: {
    id: 'fabric.editor.addLoomVideoComment',
    defaultMessage: 'Record a Loom video comment',
    description: 'Record a Loom video comment'
  },
  recordVideoDescription: {
    id: 'fabric.editor.recordVideo.description',
    defaultMessage: 'Record and share your screen and thoughts',
    description: 'Record and share your screen and thoughts'
  },
  recordLoomShortTitle: {
    id: 'fabric.editor.recordLoomShortTitle',
    defaultMessage: 'Record',
    description: 'Record'
  },
  turnInto: {
    id: 'fabric.editor.turnInto',
    defaultMessage: 'Turn into',
    description: 'Turn selected texts into another element containing those texts'
  }
});